{
  "_format": "hh-sol-artifact-1",
  "contractName": "LYTPoolServiceConfiguration",
  "sourceName": "contracts/LYTPoolServiceConfiguration.sol",
  "abi": [
    {
      "inputs": [],
      "name": "AccessControlBadConfirmation",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "bytes32",
          "name": "neededRole",
          "type": "bytes32"
        }
      ],
      "name": "AccessControlUnauthorizedAccount",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "target",
          "type": "address"
        }
      ],
      "name": "AddressEmptyCode",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "ERC1967InvalidImplementation",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ERC1967NonPayable",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FailedCall",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidInitialization",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotInitializing",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UUPSUnauthorizedCallContext",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "slot",
          "type": "bytes32"
        }
      ],
      "name": "UUPSUnsupportedProxiableUUID",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UpgradeRevert",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "version",
          "type": "uint64"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LYTPoolFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "LiquidityAssetSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "ParameterSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolAdminWalletSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bool",
          "name": "paused",
          "type": "bool"
        }
      ],
      "name": "ProtocolPaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "AUTOMATION_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BORROWER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEPLOYER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FEE_COLLECTOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FIAT_GATEWAY",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "OPERATOR_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAUSER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "POOL_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "UPGRADE_INTERFACE_VERSION",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLYTPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLegacyFactories",
      "outputs": [
        {
          "components": [
            {
              "internalType": "enum IFactoryType",
              "name": "factoryType",
              "type": "uint8"
            },
            {
              "internalType": "address",
              "name": "factoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct LegacyFactoryStruct[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressListV5",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolRegistryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "lytPoolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "lytPoolControllerFactoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct ServiceAddressListV5",
          "name": "setLoanFactoryServiceAddressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isAutomation",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isBorrower",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isDeployer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFeeCollector",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFiatGateway",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isLiquidityAsset",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isOperator",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isPoolAdmin",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "legacyFactories",
      "outputs": [
        {
          "internalType": "enum IFactoryType",
          "name": "factoryType",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "factoryAddress",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "liquidityAssetKeys",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "lytPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "callerConfirmation",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLYTPoolFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "setLiquidityAsset",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bool",
          "name": "paused_",
          "type": "bool"
        }
      ],
      "name": "setPaused",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolAdminWallet",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
